export * from './modal.service';
export * from './details.service';
